// CityPosts.js  

import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LooksPostsContext } from '../contexts/LooksPostsContext';
import LooksPost from './LooksPost';
import { Typography } from '@mui/material';
import './UsersPosts.css';                // ← reuse existing styling

const CityPosts = () => {
  const { city } = useParams();
  const { posts } = useContext(LooksPostsContext);
  const [cityPosts, setCityPosts] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (city && posts.length) {
      const filtered = posts.filter(
        (p) =>
          p.city === city &&
          !p.deleted &&
          !p.isReported &&
          (p.showOnHomePage || p.showInDiscoverBox)
      );
      setCityPosts(filtered);
    }
  }, [city, posts]);

  return (
    <div className="users-posts-container">
      <h1>
        <span className="location-link">{city}</span>
      </h1>

      {cityPosts.length ? (
        cityPosts.map((post) => <LooksPost key={post.id} {...post} />)
      ) : (
        <Typography variant="body1" color="text.secondary">
          No posts found in this city.
        </Typography>
      )}
    </div>
  );
};

export default CityPosts;
